import gql from "graphql-tag";

export default gql`
  mutation createOrderPartner($orderId: ID!, $userId: ID!, $consumerId: ID) {
    createOrderPartner(
      orderId: $orderId
      userId: $userId
      consumerId: $consumerId
    ) {
      orderId
      consumerId
      status
      userId
      createdAt
      updatedAt
      comments
      files {
        bucket
        key
        region
        identityId
        __typename
      }
      order {
        id
        userId
        serviceId
        serviceTitle
        status
        paid
        serviceData {
          deliveryHours
          __typename
        }
        category {
          title
          description
          slug
          isVisible
          __typename
        }
        createdAt
        updatedAt
        amount
        discount
        partnerAssignedId
        __typename
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Mutation/CreateOrderPartner.js